import { clsx } from 'clsx';
import type { ReactNode } from 'react';

export interface CardHeaderProps {
    className?: string;
    children: ReactNode;
}

const CardHeader = ({ className, children }: CardHeaderProps) => {
    return <div className={clsx('flex flex-col space-y-1.5 bg-gray-50/40 p-4 pb-2', className)}>{children}</div>;
};

export default CardHeader;
